import { render, staticRenderFns } from "./ReviewSiteForm.vue?vue&type=template&id=4d704f6b&scoped=true&"
import script from "./ReviewSiteForm.vue?vue&type=script&lang=js&"
export * from "./ReviewSiteForm.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSiteForm.vue?vue&type=style&index=0&id=4d704f6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d704f6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSwitch,VTextField,VTextarea})
